<template>
  <div class="w-full text-whitebase pt-12" ref="container">
    <div class="text-xl mb-4 font-bold">PASS Basic Information</div>

    <div class="relative space-y-6">
      <div>
        <div class="text-black flex mb-3">
          <span> PASS logo </span>
          <div
            class="ml-2 h-6 px-2 rounded flex items-center"
            style="
              color: #ff5585ff;
              border: 1px solid rgba(255, 81, 102, 0.4);
              background: rgba(255, 81, 102, 0.1);
            "
          >
            required
          </div>
        </div>
        <PhotoUpload
          v-model="formInfo.passLogo"
          :size="88"
          name="PASS logo"
        ></PhotoUpload>
      </div>

      <div class="grid grid-cols-2 gap-6">
        <UiInput
          ref="passInput"
          v-model="formInfo.passName"
          label="PASS Name"
          placeholder="Enter PASS Name:"
          required
          :rules="['normalStr']"
          :maxLegnth="60"
          showError
        ></UiInput>
        <UiInput
          ref="symbolInput"
          v-model="formInfo.passSymbol"
          label="Symbol"
          placeholder="Please Enter"
          required
          :rules="['symbol']"
          :uppercase="true"
          showError
        ></UiInput>
      </div>

      <div class="text-xl font-bold">WAYS TO CREATE YOUR NFTS PASS</div>

      <div
        class="rounded p-2 space-x-2 flex bg-white-005"
        style="width: fit-content"
      >
        <div
          class="
            px-6
            rounded-lg
            flex
            items-center
            h-10
            transition-all
            cursor-pointer
            font-bold
          "
          v-for="(text, i) in ['FixedPrice', 'BondingCurve', 'StakingBased']"
          :style="`background:${
            i == state.passType
              ? 'linear-gradient(315deg, #FF5585 0%, #268CFF 100%);'
              : ''
          }`"
          @click="state.passType = i"
          :key="i"
        >
          {{ text }}
        </div>
      </div>

      <div class="space-y-4 pb-6">
        <router-view></router-view>

        <div class="pb-6">
          <!-- <div>
            If you don't have the demand to create the NFT PASSes for your
            community or don't wanna generate them right away, you can
            <span
              class="text-base font-bold underline cursor-pointer"
              @click="$router.replace('/create/dashboard')"
            >
              &nbsp;SKIP&nbsp;
            </span>
            the PASS settings and
            <span class="text-base font-bold"
              >Go over to other sections in the left.</span
            >
          </div> -->

          <WhitelistCard
            passType="fixed_price"
            v-if="
              formInfo.passType == 'fixed_price' &&
              formInfo.passFixedPrice.isWhiteList
            "
          ></WhitelistCard>

          <WhitelistCard
            passType="staking_based"
            v-if="
              formInfo.passType == 'staking_based' &&
              formInfo.passStakingBasedDTO.isWhiteList
            "
          ></WhitelistCard>
        </div>
      </div>

      <div
        v-if="createState.passStatus || formInfo.createPass"
        class="absolute top-0 w-full h-full z-top"
      ></div>
    </div>
  </div>

  <div
    v-if="isEditDao"
    class="fixed bg-white pb-6 z-top"
    :class="{ hidden: formInfo.createPass }"
    :style="`bottom:0;width:${width}px`"
  >
    <div
      class="h-14 w-full rounded flex justify-end items-center px-4"
      style="background: #2a2b2d"
    >
      <div
        class="ready-btn"
        v-if="!createState.passStatus"
        @click="onCreateBtn()"
        :class="{
          disabled: !canSubmited,
        }"
      >
        Deploy Pass
      </div>
    </div>
  </div>
  <div
    v-else
    class="fixed bg-white pb-6 z-top"
    :style="`bottom:0;width:${width}px`"
  >
    <div
      class="h-14 w-full rounded flex justify-between items-center px-4"
      style="background: #2a2b2d"
    >
      <div class="ready-btn-back" @click="$router.replace('/create/dao')">
        Back
      </div>
      <div class="flex space-x-2">
        <!--      <div class="flex space-x-2" v-if="formInfo.createPass">-->
        <!-- <div class="ready-btn-back" @click="doNext(true)">I'm ready to DAO</div> -->

        <div
          class="ready-btn-back"
          v-if="!createState.passStatus"
          @click="doSkip()"
        >
          Skip
        </div>
        <!-- 未部署是 deploy，部署完成时 NEXT，部署完成后不能编辑 -->
        <div
          class="ready-btn"
          v-if="!createState.passStatus"
          @click="onCreateBtn()"
          :class="{
            disabled: !canSubmited,
          }"
        >
          Deploy Pass
        </div>
      </div>
    </div>
  </div>

  <Dialog :visible="state.showInfo" @close="state.showInfo = false">
    <div class="text-whitebase text-lg font-bold mt-10">
      Confirm Configuration
    </div>
    <div style="color: #737373" class="text-sm mt-2 font-bold">
      Confirm the configuration you fill in, once it deployed, some of the
      configuration cannot be changed.
    </div>

    <UiScrollbars class="h-80 w-full mt-4">
      <ERC20Confirm :info="formInfo"></ERC20Confirm>
    </UiScrollbars>

    <div class="flex justify-end mt-6">
      <UiButton type="outline" @click="state.showInfo = false">Cancel</UiButton>
      <div class="mr-4"></div>
      <UiButton error @click="deploy">Deploy Now</UiButton>
    </div>
  </Dialog>

  <!-- <Dialog
    :visible="createState.showDashboard"
    textAlign="left"
    @close="createState.showDashboard = false"
    text="Dashboard is committed to providing transparent data about DAO treasury including FT vault and NFT vault.<br/><br/>Do you need it?"
    okText="Yes I do"
    @ok="() => $router.push('/create/dashboard')"
    cancelText="No thanks"
  ></Dialog> -->
</template>

<script setup>
import {
  computed,
  inject,
  onMounted,
  provide,
  reactive,
  ref,
  watch,
} from 'vue';
import PhotoUpload from './component/PhotoUpload.vue';
import UiInput from './component/UiInput.vue';
import UiButton from '@/components/UiButton.vue';
import { useRoute, useRouter } from 'vue-router';
import { getNetworkName } from '@/utils/wallet';
import { withThrottling, withWalletFlow } from '@/utils/with';
import { checkPassExist, extendCreatePass, sendDaoTxHash } from '@/api/dao';
import { notify } from '@kyvg/vue3-notification';
import {
  BONDING_CURVE_OPTIONS_BY_NETWORK,
  FIXED_PRICE_OPTIONS_BY_NETWORK,
  NetworkType,
} from '@/constants';
import { useNetwork } from '@/hooks';
import BigNumber from 'bignumber.js';
import Dialog from '@/components/Dialog.vue';
import WhitelistCard from './component/WhitelistCard.vue';
import mitt, { mittContract, mittLoading, mittNetwork } from '@/libs/event';
import { useElementSize } from '@vueuse/core';
import { useIsEditDao } from './constanst';
import { getFactoryMethods } from '@/constants/contract';
import { getUTCTime, handleWalletError } from '@/utils';
import dayjs from 'dayjs';
import ERC20Confirm from '@/components/CreateDAO/ERC20Confirm.vue';
import UiScrollbars from '@/components/UiScrollbars.vue';
import { checkNetwork } from '@/libs/check';

const $route = useRoute();
const $router = useRouter();
const network = useNetwork();
const isEditDao = useIsEditDao();

const formInfo = inject('formInfo');
const createState = inject('createState');

const passInput = ref(null);
const symbolInput = ref(null);
const container = ref(null);

const { width } = useElementSize(container);

/*
  TODO 编辑状态下未创建pass的可以创建pass，已创建pass的只能进行查看
 */

const state = reactive({
  passType: 0,
  passExsited: false,
  showInfo: false,
  created: false /* check pass whether created. */,
});

const checks = reactive({
  checkFixedPrice: false,
  checkBondingCurve: false,
  checkStakingBase: false,
});
provide('checks', checks);

const getPath = (type) => {
  if (!isEditDao.value) {
    return `/create/pass/${type}`;
  }
  return `/pass_settings/${$route.params.name}/pass/${type}`;
};

const passTypeTabs = computed(() => {
  return [
    { label: 'FixedPrice', path: 'fp', value: 'fixed_price' },
    {
      label: 'BondingCurve',
      path: 'bc',
      value: 'bonding_curve',
    },
    {
      label: 'StakingBased',
      path: 'sb',
      value: 'staking_based',
    },
  ];
});

const canSubmited = computed(() => {
  return (
    !state.passExsited &&
    (passInput.value ? !passInput.value.checkRule() : false) &&
    (symbolInput.value ? !symbolInput.value.checkRule() : false) &&
    formInfo.passLogo &&
    ((formInfo.passType == 'fixed_price' && checks.checkFixedPrice) ||
      (formInfo.passType == 'bonding_curve' && checks.checkBondingCurve) ||
      (formInfo.passType == 'staking_based' && checks.checkStakingBase))
  );
});

['passName', 'passLogo', 'passSymbol'].forEach((key) => {
  watch(
    () => JSON.stringify(formInfo[key]),
    async (value) => {
      const val = JSON.parse(value);

      if (key === 'passName' && val) {
        const prev = val;
        const flag = !(await checkPassExist(val));
        if (prev == formInfo[key]) {
          state.passExsited = flag;
          passInput.value.setErrorMsg(flag ? 'Pass has exsited.' : '');
        }
      }
    },
  );
});

const onCreateBtn = withThrottling(
  withWalletFlow(
    async function () {
      if (!formInfo.id) {
        notify({
          type: 'error',
          text: 'Have to insert information in DAO settings first!',
        });
        return;
      }
      await checkNetwork();

      /* BC-CHECK */
      if (formInfo.passType == 'bonding_curve') {
        const { collateralTokens, initialPrice, m, n } =
          formInfo.passBondingCurve;

        const decimals = BONDING_CURVE_OPTIONS_BY_NETWORK(network.value)[
          collateralTokens
        ].decimals;

        if (new BigNumber(initialPrice).lt(m)) {
          notify({
            type: 'error',
            text: 'The initial price must >= the config m.',
          });
          return;
        }

        const minM = new BigNumber('10').pow(new BigNumber('-' + decimals));

        /* basic */
        const minPrice = minM.dividedBy(new BigNumber('0.0000002'));

        const isBasic = new BigNumber(m).eq(
          new BigNumber(initialPrice).multipliedBy(new BigNumber('0.0000002')),
        );

        if (minM.gt(new BigNumber(m))) {
          if (isBasic) {
            notify({
              type: 'error',
              text: `Initial Price must =${minPrice.toString(
                10,
              )} or >=${minPrice.multipliedBy(2).toString(10)}`,
            });
          } else {
            notify({
              type: 'error',
              text: `Config variable M can't over ${minM.toString(10)}`,
            });
          }

          return;
        }

        if (isBasic) {
          if (new BigNumber(initialPrice).lt(minPrice)) {
            notify({
              type: 'error',
              text: `Initial Price can't be less than ${minPrice.toString(10)}`,
            });
            return;
          }
        }
      }

      if (formInfo.passType == 'staking_based') {
        if (formInfo.validityType == 'certain_time') {
          notify({
            type: 'error',
            text: "CertaiinTime can't empty",
          });
          return;
        }
      }

      /* check daoInfo */

      if (
        !formInfo.name ||
        !formInfo.logo ||
        formInfo.daoTag.length == 0 ||
        !formInfo.website ||
        !formInfo.twitter
      ) {
        notify({
          type: 'error',
          text: "Dao Info hasn't completed",
        });
        return;
      }

      state.showInfo = true;
    },
    () => network.value,
  ),
);

const onlyCreatePass = async () => {
  const networkType = await getNetworkName();
  const networkx = NetworkType[networkType];

  let params = {
    passLogo: formInfo.passLogo,
    passName: formInfo.passName,
    passSymbol: formInfo.passSymbol,
    passType: formInfo.passType,
    passBondingCurve: {
      ...formInfo.passBondingCurve,
      network: networkx,
    },
    passFixedPrice: {
      ...formInfo.passFixedPrice,
      network: networkx,
      supply: formInfo.passFixedPrice.supply || '-1',
      certainTime: formInfo.passFixedPrice.certainTime
        ? new Date(formInfo.passFixedPrice.certainTime).getTime()
        : '',
      schedulingAhead: formInfo.passFixedPrice.schedulingAhead
        ? new Date(formInfo.passFixedPrice.schedulingAhead).getTime()
        : '',
      duration: formInfo.passFixedPrice.duration
        ? new Date(formInfo.passFixedPrice.duration).getTime()
        : '',
      isWhiteList: +formInfo.passFixedPrice.isWhiteList,
    },
    passStakingBasedDTO: {
      ...formInfo.passStakingBasedDTO,
      network: networkx,
      duration: formInfo.passStakingBasedDTO.duration
        ? new Date(formInfo.passStakingBasedDTO.duration).getTime()
        : '',
      schedulingAhead: formInfo.passStakingBasedDTO.schedulingAhead
        ? new Date(formInfo.passStakingBasedDTO.schedulingAhead).getTime()
        : '',
      isWhiteList: +formInfo.passStakingBasedDTO.isWhiteList,
    },
  };

  return extendCreatePass({ daoId: formInfo.id, ...params });
};

const deploy = withThrottling(async function () {
  const lid = Date.now();

  try {
    state.showInfo = false;
    const { passType } = formInfo;
    const { passStakingBasedDTO, passFixedPrice } = formInfo;

    mittLoading(lid);

    const doDeploy = await getFactoryMethods(
      passType,
      passStakingBasedDTO.tokenMintTheNftPass,
    );

    await onlyCreatePass();
    mittLoading(lid, false);

    if (
      (passType === 'fixed_price' &&
        passFixedPrice.schedulingAhead &&
        dayjs(passFixedPrice.schedulingAhead).isAfter(getUTCTime())) ||
      (passType === 'staking_based' &&
        passStakingBasedDTO.schedulingAhead &&
        dayjs(passStakingBasedDTO.schedulingAhead).isAfter(getUTCTime()))
    ) {
      if (!isEditDao.value) {
        $router.replace('/create/treasury');
        createState.passStatus = true;
      } else {
        mitt.emit('tip', {
          okText: 'Sure',
          text: 'Cannot deploy until the scheduling time',
        });
      }

      return;
    }

    mittContract(true, true);
    const tx = await doDeploy({
      name: formInfo.passName,
      symbol: formInfo.passSymbol,
      daoName: formInfo.name,
      address:
        formInfo.passStakingBasedDTO.tokenContractAddress ||
        formInfo.passStakingBasedDTO.nftContractAddress,
      num: formInfo.passStakingBasedDTO.tokensNeededToMintANft,
      receiveAddress:
        passType === 'fixed_price'
          ? FIXED_PRICE_OPTIONS_BY_NETWORK(network.value)[
              formInfo.passFixedPrice.payWith
            ].address
          : '',
      /* fixedPrice */
      quantity: formInfo.passFixedPrice.supply,
      payment: formInfo.passFixedPrice.payment,
      validityType: formInfo.passFixedPrice.validityType,
      certainTime: formInfo.passFixedPrice.certainTime,
      receivingAddress: formInfo.passFixedPrice.receivingAddress,
      repeatMintNum:
        passType == 'fixed_price'
          ? formInfo.passFixedPrice.mintLimit
          : formInfo.passStakingBasedDTO.mintLimit,
      isNotWhitelist:
        passType == 'fixed_price'
          ? formInfo.passFixedPrice.isWhiteList
          : formInfo.passStakingBasedDTO.isWhiteList,
      mintDeadlineTime:
        passType == 'fixed_price'
          ? formInfo.passFixedPrice.duration
          : formInfo.passStakingBasedDTO.duration,
      /* fixedPrice */

      bond_receiver_addr: formInfo.passBondingCurve.receivingAddress,
      bond_rate: formInfo.passBondingCurve.creatorFee,
      bond_init_price: formInfo.passBondingCurve.initialPrice,
      bond_token: formInfo.passBondingCurve.collateralTokens,
      bond_m: formInfo.passBondingCurve.m,
      bond_n: formInfo.passBondingCurve.n,
      bond_d: formInfo.passBondingCurve.d,
    });
    await tx.wait();
    await sendDaoTxHash(tx.hash, formInfo.id);

    mittContract(false);

    if (isEditDao.value) {
      formInfo.createPass = true;
      notify({
        type: 'success',
        text: 'Deployed Successfully!',
      });
    } else {
      createState.passStatus = true;
      $router.replace('/create/treasury');
    }
  } catch (error) {
    if (error.code) {
      formInfo.createPass = true;
    }

    mittLoading(lid, false);
    mittContract(false);
    handleWalletError(error);
  }
});

const doSkip = () => {
  $router.replace('/create/treasury');
};

watch(
  () => state.passType,
  (x) => {
    console.log(getPath(passTypeTabs.value[x].path));

    $router.replace(getPath(passTypeTabs.value[x].path));
  },
);

const refreshPassType = () => {
  // if (!/\/create\/pass/.test($route.path)) {
  //   return;
  // }

  const index = passTypeTabs.value.findIndex(
    (x) => getPath(x.path) == $route.path,
  );
  state.passType = index == -1 ? 0 : index;
  formInfo.passType = passTypeTabs.value[state.passType].value;
};

watch(
  () => $route.path,
  () => {
    refreshPassType();
  },
);

onMounted(() => {
  if (network.value == 'tezos') {
    // mittNetwork(true, true);
  } else {
    refreshPassType();
  }
});
</script>

<style lang="scss" scoped></style>
